import type { ModalField, UserDetails } from './modalFieldHelpers'
import {
  isCreateUser,
  isEditUser,
  isActivateDeactivateUser,
  isChangePassword,
  isDisconnectUser,
  buildBaseUserFields,
  buildCreateUserFields,
  buildEditUserFields,
  buildChangePasswordFields,
  buildDisconnectFields,
  buildActivateDeactivateFields,
} from './modalFieldHelpers'

export function getModalFields(selectedRow: unknown, translate: (key: string) => string): readonly ModalField[] {
  if (!selectedRow) return []

  const details = selectedRow as UserDetails

  const createUser = isCreateUser(details)
  const editUser = isEditUser(details)
  const activateDeactivate = isActivateDeactivateUser(details)
  const changePassword = isChangePassword(details)
  const disconnect = isDisconnectUser(details)

  if (createUser) {
    // Para ação de criação, exibir apenas o conjunto específico solicitado
    return buildCreateUserFields(details, translate)
  }

  if (editUser) {
    // Para edição, exibir o conjunto específico solicitado (mesmo formato
    // de campos do 'create', mas com um único 'Grupo de Despacho')
    return buildEditUserFields(details, translate)
  }

  if (activateDeactivate) {
    return buildActivateDeactivateFields(details, translate)
  }

  if (changePassword) {
    return buildChangePasswordFields(details, translate)
  }

  if (disconnect) {
    return buildDisconnectFields(details, translate)
  }

  return buildBaseUserFields(details, translate)
}

export default getModalFields
